import { Directive, ElementRef, Renderer2, Input, OnInit, HostListener } from '@angular/core';

export type NcObjectFitType = 'contain' | 'cover' | 'fill';

@Directive({
	selector: '[ncImgZoom]',
	exportAs: 'ncImgZoom'
})
export class ImgZoomDirective implements OnInit {
	/** 最小缩放比例 */
	@Input() ncMinScale = 0.5;
	/** 最大缩放比例 */
	@Input() ncMaxScale = 5;
	/** 图片缩放模式 */
	@Input() ncObjectFit: NcObjectFitType = 'contain';

	private scale = 1;
	private position = { x: 0, y: 0 };
	private isDragging = false;
	private lastPosition = { x: 0, y: 0 };

	constructor(private el: ElementRef, private renderer: Renderer2) { }

	ngOnInit() {
		this.initializeStyles();
	}

	private initializeStyles() {
		//设置父元素overflow:hidden。一方面是隐藏溢出，另一方面是当父元素是flex:1时(没有设置具体的width和height)，img的object-fit才能生效
		this.renderer.setStyle(this.renderer.parentNode(this.el.nativeElement), 'overflow', 'hidden');
		this.renderer.setStyle(this.el.nativeElement, 'width', '100%');
		this.renderer.setStyle(this.el.nativeElement, 'height', '100%');
		this.renderer.setStyle(this.el.nativeElement, 'object-fit', this.ncObjectFit);
		this.renderer.setStyle(this.el.nativeElement, 'transform-origin', 'center center');
		this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grab');
	}

	@HostListener('wheel', ['$event'])
	onWheel(event: WheelEvent) {
		event.preventDefault();
		const delta = event.deltaY > 0 ? -0.1 : 0.1;
		this.scale = Math.max(this.ncMinScale, Math.min(this.ncMaxScale, this.scale + delta));
		this.updateTransform();
	}

	@HostListener('mousedown', ['$event'])
	onMouseDown(event: MouseEvent) {
		event.preventDefault();
		this.isDragging = true;
		this.lastPosition = {
			x: event.clientX - this.position.x,
			y: event.clientY - this.position.y
		};
		// 在按下时立即更新cursor样式
		this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grabbing');
	}

	@HostListener('mousemove', ['$event'])
	onMouseMove(event: MouseEvent) {
		if (!this.isDragging) return;

		this.position = {
			x: event.clientX - this.lastPosition.x,
			y: event.clientY - this.lastPosition.y
		};
		this.updateTransform();
	}

	@HostListener('mouseup', ['$event'])
	onMouseUp(event: MouseEvent) {
		this.isDragging = false;
		// 在释放时立即更新cursor样式
		this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grab');
	}

	@HostListener('mouseleave', ['$event'])
	onMouseLeave(event: MouseEvent) {
		this.isDragging = false;
		this.renderer.setStyle(this.el.nativeElement, 'cursor', 'grab');
	}

	resetView() {
		this.scale = 1;
		this.position = { x: 0, y: 0 };
		this.updateTransform();
	}

	private updateTransform() {
		this.renderer.setStyle(this.el.nativeElement, 'transform', `scale(${this.scale}) translate(${this.position.x}px, ${this.position.y}px)`);
	}
}